import { forEach } from 'lodash'

import { batchOpacityRevealAnimation, batchScaleXRevealAnimation } from './shared'
import { Animation } from '@/types'

export const tableRevealAnimation = ({ context, reverse }: Animation) => {
  const rows = context.selector?.('[data-motion-table-row]')
  const lines = context.selector?.('[data-motion-table-row] hr')

  let rowsBatchAnimation: ScrollTrigger[]
  if (rows.length > 0) {
    rowsBatchAnimation = batchOpacityRevealAnimation({
      targets: rows,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  let linesBatchAnimation: ScrollTrigger[]
  if (lines.length > 0) {
    linesBatchAnimation = batchScaleXRevealAnimation({
      targets: lines,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(rowsBatchAnimation || [], (animation) => animation.kill())
    forEach(linesBatchAnimation || [], (animation) => animation.kill())
  }
}
